const TRIGGER_NAME_TO_LABEL: Record<string, string> = {
  reduced: 'Reduced',
  'market-success': 'Market success',
  withdrawn: 'Withdrawn',
};

export { TRIGGER_NAME_TO_LABEL };
